import * as types from "./types";
import Routes from "../../api/routes"; // API endpoint routes
import {
  get,
  getForSSR,
  getForUrl,
  getForWithoutHeader,
} from "../../api";
import { get_cookie, page_limit } from "utils";
const {
  BRAND_LIST,
  CATEGORY_LIST,
  SETTINGS,
  DYNAMIC_PAGES_LIST,
  LOCATIONS,
  FEATURES,
  SEO_TAGS,
  VEHICLE_FILTER_INPUT,
  VEHICLE_FILTER,
  FAQS,
  BLOGS,
  BRAND_VEHICLE_LIST,
  GET_COUTNRIES,
  GET_STATES,
  GET_CITIES,
  INSURANCE_CARRIERS,
} = Routes;

/******************* 
@purpose :  get Brand List
@Parameter : {}
@Author : INIC
******************/
export const getBrandList = (locationId) => (dispatch) => {
  return get(`${BRAND_LIST}?location_id=${locationId}`, false, false).then(
    (res) => {
      //dispatch(toggleLoader("content_loader", false));
      if (res?.data) {
        dispatch(setBrandList(res?.data));
        return res.data;
      }
      return Promise.reject(res);
    }
  );
};

/******************** 
@purpose : set brand list
@Parameter : { data }
@Author : INIC
******************/
export const setBrandList = (data) => {
  return {
    type: types.SET_BRAND_LIST,
    data,
  };
};

/******************* 
@purpose :  get Category List
@Parameter : {}
@Author : INIC
******************/
export const getCategoryList = (locationId) => (dispatch) => {
  return getForWithoutHeader(
    `${CATEGORY_LIST}?location_id=${locationId}`,
    false,
    false
  ).then((res) => {
    //dispatch(toggleLoader("content_loader", false));
    if (res?.data) {
      dispatch(setCategoryList(res?.data));
      return res.data;
    }
    return Promise.reject(res);
  });
};

/******************** 
@purpose : set category list
@Parameter : { data }
@Author : INIC
******************/
export const setCategoryList = (data) => {
  return {
    type: types.SET_CATEGORY_LIST,
    data,
  };
};

/******************* 
@purpose :  Get Address data according to location, and  global setting
@Parameter : {}
@Author : INIC
******************/
export const getAddressInfo =
  (locationId, loader = true) =>
  (dispatch) => {
    return get(`${SETTINGS}?location_id=${locationId}`, false, loader).then(
      (res) => {
        //dispatch(toggleLoader("content_loader", false));
        if (res?.data) {
          dispatch(setAddressInfo(res?.data));
          return res.data;
        }
        return Promise.reject(res);
      }
    );
  };

/******************** 
@purpose : Set address data
@Parameter : { data }
@Author : INIC
******************/
export const setAddressInfo = (data) => {
  return {
    type: types.SET_ADDRESS_INFO,
    data,
  };
};

/******************* 
@purpose :  Get dynamic page list, show in footer
@Parameter : {}
@Author : INIC
******************/
export const getDynamicPageList = (locationId) => (dispatch) => {
  return get(
    `${DYNAMIC_PAGES_LIST}?location_id=${locationId}`,
    false,
    false
  ).then((res) => {
    //dispatch(toggleLoader("content_loader", false));
    if (res?.data) {
      dispatch(setDynamicPageList(res?.data));
      return Promise.resolve(res?.data);
    }
    return Promise.reject(res);
  });
};

/******************** 
@purpose : Set dynamic page list
@Parameter : { data }
@Author : INIC
******************/
export const setDynamicPageList = (data) => {
  return {
    type: types.SET_DYNAMIC_PAGE_LIST,
    data,
  };
};

/******************* 
@purpose :  get Location data
@Parameter : {}
@Author : INIC
******************/
export const getLocations =
  (data = false) =>
  (dispatch) => {
    return get(`${LOCATIONS}`, false, false)
      .then((res) => {
        if (res?.data && !data) {
          dispatch(setLocations(res?.data));
          return res.data;
        } else {
          return res;
        }
      })
      .catch((err) => {});
  };

/******************** 
@purpose : set Locations data
@Parameter : { data }
@Author : INIC
******************/
export const setLocations = (data) => {
  return {
    type: types.SET_LOCATION_INFO,
    data,
  };
};

/******************* 
@purpose :  get feature list
@Parameter : {}
@Author : INIC
******************/
export const getFeaturedList = () => (dispatch) => {
  return get(`${FEATURES}`, false).then((res) => {
    //dispatch(toggleLoader("content_loader", false));
    if (res?.data) {
      dispatch(setFeatures(res?.data));
      return res.data;
    }
    return Promise.reject(res);
  });
};

/******************** 
@purpose : set features data
@Parameter : { data }
@Author : INIC
******************/
export const setFeatures = (data) => {
  return {
    type: types.SET_FEATURES,
    data,
  };
};

/******************** 
@purpose : set current page
@Parameter : { data }
@Author : INIC
******************/
export const setCurrentPage = (data) => {
  return {
    type: types.SET_CURRENT_PAGE,
    data,
  };
};

/******************** 
@purpose : set current location
@Parameter : { data }
@Author : INIC
******************/
export const setCurrentLocationId = (data) => {
  return {
    type: types.SET_CURRENT_LOCATION,
    data,
  };
};

/******************* 
@purpose :  get meta data
@Parameter : {}
@Author : INIC
******************/
export const getMetaData = (locationId, slug, flag) => (dispatch) => {
  return get(
    `${SEO_TAGS}?location_id=${locationId}&${flag}=${slug}`,
    false
  ).then((res) => {
    //dispatch(toggleLoader("content_loader", false));
    if (res?.data) {
      dispatch(setMetaData(res?.data));
      return res.data;
    }
    return Promise.reject(res);
  });
};

/******************** 
@purpose : set meta data
@Parameter : { data }
@Author : INIC
******************/
export const setMetaData = (data) => {
  return {
    type: types.SET_META_DATA,
    data,
  };
};

/******************** 
@purpose : clear vehicle list
@Parameter : { data }
@Author : INIC
******************/
export const clearVehicleList = (data) => {
  return {
    type: types.SET_VEHICLE_LIST_CLEAR,
    data,
  };
};

/******************** 
@purpose : set vehicle list
@Parameter : { data }
@Author : INIC
******************/
export const setVehicleList = (data) => {
  return {
    type: types.SET_VEHICLE_LIST,
    data,
  };
};

/******************** 
@purpose : set brand vehicle meta data
@Parameter : { data }
@Author : INIC
******************/
export const setVehicleMetaData = (data) => {
  return {
    type: types.SET_VEHICLE_META_DATA,
    data,
  };
};

/******************** 
@purpose : set total record for brand vehicle
@Parameter : { data }
@Author : INIC
******************/
export const setVehicleTotalRecord = (data) => {
  return {
    type: types.SET_VEHICLE_TOTAL_RECORD,
    data,
  };
};

/******************* 
@purpose :  Get load more data 
@Parameter : {}
@Author : INIC
******************/
export const getLoadMoreData = (url) => (dispatch) => {
  let token = get_cookie("token");
  const correctLocationId = get_cookie("currentLocationId");
  // Fix: Backend returns links.next with double-encrypted location_id for guests.
  // Replace with correct single-encrypted value from cookie.
  if (correctLocationId && url) {
    try {
      const urlObj = new URL(url);
      urlObj.searchParams.set("location_id", correctLocationId);
      url = urlObj.toString();
    } catch (e) {}
  }
  return getForUrl(`${url}&page_limit=${page_limit}`, false).then((res) => {
    if (res?.data) {
      dispatch(setVehicleList(res?.data));
      dispatch(setVehicleMetaData(res));
      return Promise.resolve(res);
    }
    return Promise.reject(res);
  });
};

/******************* 
@purpose :  Get filter input
@Parameter : {slug}
@Author : INIC
******************/
export const getFilterInput = (locationId, slug, flag) => (dispatch) => {
  let url = `${VEHICLE_FILTER_INPUT}?location_id=${locationId}&brand_slug=${slug}`;
  if (flag !== "brand") {
    url = `${VEHICLE_FILTER_INPUT}?location_id=${locationId}&category_slug=${slug}`;
  }
  return get(url, false).then((res) => {
    //dispatch(toggleLoader("content_loader", false));
    if (res?.data) {
      return Promise.resolve(res.data);
    }
    return Promise.reject(res);
  });
};

/******************* 
@purpose :  Get vehicle filter data
@Parameter : {slug}
@Author : INIC
******************/
export const getVehicleFilterData =
  (
    locationId,
    slug,
    categoryStr = "",
    colorStr = "",
    minPrice,
    maxPrice = "",
    seats = [],
    flag = "",
    brandStr = "",
    selectedPage,
    sortBy = ""
  ) =>
  () => {
    let url = "";

    if (selectedPage != "brand") {
      if (flag == 1) {
        // only get count
        url = `${VEHICLE_FILTER}?location_id=${locationId}&category_slug=${slug}&min_price=${minPrice}&max_price=${maxPrice}&seats[]=${seats.join(
          "&seats[]="
        )}&${brandStr}&${colorStr}&count=1`;
      } else {
        // all data
        url = `${VEHICLE_FILTER}?location_id=${locationId}&category_slug=${slug}`;
        url = url + `&min_price=${minPrice}`;

        if (maxPrice) {
          url = url + `&max_price=${maxPrice}`;
        }
        if (seats && seats.length > 0) {
          url += `&seats[]=${seats.join("&seats[]=")}`;
        }
        if (brandStr) {
          url = url + `&${brandStr}`;
        }
        if (colorStr) {
          url = url + `&${colorStr}`;
        }
      }
    } else {
      if (flag == 1) {
        // only get count
        url = `${VEHICLE_FILTER}?location_id=${locationId}&brand_slug=${slug}&min_price=${minPrice}&max_price=${maxPrice}&seats[]=${seats.join(
          "&seats[]="
        )}&${categoryStr}&${colorStr}&count=1`;
      } else {
        // all data
        url = `${VEHICLE_FILTER}?location_id=${locationId}&brand_slug=${slug}`;
        url = url + `&min_price=${minPrice}`;

        if (maxPrice) {
          url = url + `&max_price=${maxPrice}`;
        }
        if (seats) {
          const seatsArray = Array.isArray(seats) ? seats : [seats];
          if (seatsArray.length > 0) {
            url += `&seats[]=${seatsArray.join("&seats[]=")}`;
          }
        }
        if (categoryStr) {
          url = url + `&${categoryStr}`;
        }
        if (colorStr) {
          url = url + `&${colorStr}`;
        }
      }
    }

    if (sortBy) {
      url = url + `&sort_by=${sortBy}`;
    }

    return getForSSR(
      url,
      false,
      flag == 1 ? false : true,
      get_cookie("token")
    ).then((res) => {
      if (res?.data) {
        return Promise.resolve(res);
      }
      return Promise.reject(res);
    });
  };

/******************* 
@purpose :  get faqs list
@Parameter : {}
@Author : INIC
******************/
export const getFaqs = () => (dispatch) => {
  return get(`${FAQS}`, false).then((res) => {
    if (res?.data) {
      return res.data;
    }
    return Promise.reject(res);
  });
};

/******************* 
@purpose :  get cms list
@Parameter : {}
@Author : INIC
******************/
export const getCmsList = () => (dispatch) => {
  return get(`${BLOGS}?type=CMS`, false).then((res) => {
    if (res?.data) {
      dispatch(setCmsList(res?.data));
      return res?.data;
    }
    return Promise.reject(res);
  });
};

/******************** 
@purpose : set cms list
@Parameter : { data }
@Author : INIC
******************/
export const setCmsList = (data) => {
  return {
    type: types.SET_CMS_LIST,
    data,
  };
};

/******************* 
@purpose :  get Brand List
@Parameter : {}
@Author : INIC
******************/
export const getbrandVehicleList = (brandId, locationId) => (dispatch) => {
  return get(
    `${BRAND_VEHICLE_LIST}/${brandId}/vehicles?location_id=${locationId}`,
    false,
    false
  ).then((res) => {
    //dispatch(toggleLoader("content_loader", false));
    if (res?.data) {
      dispatch(setbrandVehicleList(res?.data));
      return res.data;
    }
    return Promise.reject(res);
  });
};

/******************** 
@purpose : set brand list
@Parameter : { data }
@Author : INIC
******************/
export const setbrandVehicleList = (data) => {
  return {
    type: types.SET_VEHICLE_LIST_BY_BRAND,
    data,
  };
};

/*******************
@purpose : place order
@Parameter : {data}
@Author : INIC
******************/
/*******************
@purpose : get insurance carriers managed in admin Global Settings
@Parameter : {}
******************/
export const getInsuranceCarriers = () => () =>
  get(INSURANCE_CARRIERS, false, false).then((res) => {
    if (res?.statusCode == 200 && Array.isArray(res?.data?.carriers)) {
      return res.data.carriers;
    }
    return Promise.reject(res);
  });

export const getCountryList =
  (setList = true, loader = false) =>
  (dispatch) => {
    return get(GET_COUTNRIES, true, loader).then((res) => {
      if (res?.statusCode == 200) {
        if (setList) dispatch(setCountriesList(res.data));
        return res.data;
      }
      return Promise.reject(res);
    });
  };

/******************** 
@purpose : set country list
@Parameter : { data }
@Author : INIC
******************/
export const setCountriesList = (data) => {
  return {
    type: types.SET_COUNTRIES_LIST,
    data,
  };
};

/*******************
@purpose : place order
@Parameter : {data}
@Author : INIC
******************/
export const getStateList =
  (countryId, loader = false) =>
  (dispatch) => {
    return get(GET_STATES.replace("id", countryId), true, loader).then(
      (res) => {
        if (res?.statusCode == 200) {
          dispatch(setStatesList(res.data));
          return res.data;
        }
        return Promise.reject(res);
      }
    );
  };

/******************** 
@purpose : set brand list
@Parameter : { data }
@Author : INIC
******************/
export const setStatesList = (data) => {
  return {
    type: types.SET_STATES_LIST,
    data,
  };
};
/*******************
@purpose : place order
@Parameter : {data}
@Author : INIC
******************/
export const getCityList =
  (stateId, loader = false) =>
  (dispatch) => {
    return get(GET_CITIES.replace("id", stateId), true, loader).then((res) => {
      if (res?.statusCode == 200) {
        dispatch(setCitiesList(res.data));
        return res.data;
      }
      return Promise.reject(res);
    });
  };

/******************** 
@purpose : set brand list
@Parameter : { data }
@Author : INIC
******************/
export const setCitiesList = (data) => {
  return {
    type: types.SET_CITIES_LIST,
    data,
  };
};

/******************* 
@purpose :  get Location info using id
@Parameter : {}
@Author : INIC
******************/
export const getLocationInfo = (id) => (dispatch) => {
  return get(`${LOCATIONS}/${id}`, false, false)
    .then((res) => {
      if (res?.data) {
        return res.data;
      }
      return Promise.reject(res ? res : "fail");
    })
    .catch((err) => console.log(err));
};

/******************** 
@purpose : update filter click count
@Parameter : {}
@Author : INIC
******************/
export const updateFilterClickCount = (data) => {
  return {
    type: types.UPDATE_FILTER_CLICK_COUNT,
    data: data,
  };
};

/******************** 
@purpose : update share click count
@Parameter : {}
@Author : INIC
******************/
export const updateShareClickCount = (data) => {
  return {
    type: types.UPDATE_SHARE_CLICK_COUNT,
    data: data,
  };
};

/******************** 
@purpose : set selected page name
@Parameter : {}
@Author : INIC
******************/
export const setSelectedPage = (data) => {
  return {
    type: types.SET_SELECTED_PAGE,
    data: data,
  };
};

/******************** 
@purpose : set selected page name
@Parameter : {}
@Author : INIC
******************/
export const setSelectedSlug = (data) => {
  return {
    type: types.SET_SELECTED_SLUG,
    data: data,
  };
};

/******************** 
@purpose : ADD REMOVE BRAND CATEGORY SLUG
@Parameter : {}
@Author : INIC
******************/
export const addRemoveBrandCategorySlug = (data) => {
  return {
    type: types.ADD_REMOVE_BRAND_CATEGORY_SLUG,
    data: data,
  };
};

/******************** 
@purpose : Add Remove Color
@Parameter : {}
@Author : INIC
******************/
export const addRemoveColor = (data) => {
  return {
    type: types.ADD_REMOVE_COLOR,
    data: data,
  };
};

/******************** 
@purpose : Add Remove Seat
@Parameter : {}
@Author : INIC
******************/
export const addRemoveSeat = (data) => {
  return {
    type: types.ADD_REMOVE_SEAT,
    data: data,
  };
};

/******************** 
@purpose : Add Remove Price
@Parameter : {}
@Author : INIC
******************/
export const addRemovePrice = (data) => {
  return {
    type: types.ADD_REMOVE_PRICE,
    data: data,
  };
};

/******************** 
@purpose : Clear filter options
@Parameter : {}
@Author : INIC
******************/
export const clearCategoryBrandColorSeatPriceValue = () => {
  return {
    type: types.CLEAR_CATEGORY_BRAND_COLOR_SEAT_PRICE,
    data: "",
  };
};
